import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["container", "template", "emptyState"];

  add(event) {
    event.preventDefault();
    const content = this.templateTarget.innerHTML.replace(
      /NEW_RECORD/g,
      new Date().getTime(),
    );
    this.containerTarget.insertAdjacentHTML("beforeend", content);

    // Hide empty state if it exists
    if (this.hasEmptyStateTarget) {
      this.emptyStateTarget.remove();
    }
  }

  remove(event) {
    event.preventDefault();
    const wrapper = event.target.closest(".nested-fields");

    if (wrapper.dataset.newRecord === "true") {
      wrapper.remove();
    } else {
      wrapper.classList.add("hidden");
      wrapper.querySelector("input[name*='_destroy']").value = "1";
    }
  }
}
